import { render } from "./ContactsViewFullKit.vue?vue&type=template&id=ad168df6"
import script from "./ContactsViewFullKit.vue?vue&type=script&lang=js"
export * from "./ContactsViewFullKit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__